import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const h=t("toll",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_66402"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="25">
                <rect
                    y="0.186523"
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_66402)">
                <path
                    d="M15 20.1865C12.7667 20.1865 10.875 19.4115 9.325 17.8615C7.775 16.3115 7 14.4199 7 12.1865C7 9.95319 7.775 8.06152 9.325 6.51152C10.875 4.96152 12.7667 4.18652 15 4.18652C17.2333 4.18652 19.125 4.96152 20.675 6.51152C22.225 8.06152 23 9.95319 23 12.1865C23 14.4199 22.225 16.3115 20.675 17.8615C19.125 19.4115 17.2333 20.1865 15 20.1865ZM5.625 19.4365C4.225 18.7865 3.10417 17.8115 2.2625 16.5115C1.42083 15.2115 1 13.7699 1 12.1865C1 10.6032 1.42083 9.16152 2.2625 7.86152C3.10417 6.56152 4.225 5.58652 5.625 4.93652C5.975 4.76986 6.29167 4.78236 6.575 4.97402C6.85833 5.16569 7 5.47819 7 5.91152C7 6.07819 6.94583 6.24069 6.8375 6.39902C6.72917 6.55736 6.59167 6.67819 6.425 6.76152C5.375 7.24486 4.54167 7.97402 3.925 8.94902C3.30833 9.92402 3 11.0032 3 12.1865C3 13.3699 3.30833 14.449 3.925 15.424C4.54167 16.399 5.375 17.1282 6.425 17.6115C6.59167 17.6949 6.72917 17.8115 6.8375 17.9615C6.94583 18.1115 7 18.2782 7 18.4615C7 18.8782 6.85833 19.1865 6.575 19.3865C6.29167 19.5865 5.975 19.6032 5.625 19.4365ZM15 18.1865C16.6667 18.1865 18.0833 17.6032 19.25 16.4365C20.4167 15.2699 21 13.8532 21 12.1865C21 10.5199 20.4167 9.10319 19.25 7.93652C18.0833 6.76986 16.6667 6.18652 15 6.18652C13.3333 6.18652 11.9167 6.76986 10.75 7.93652C9.58333 9.10319 9 10.5199 9 12.1865C9 13.8532 9.58333 15.2699 10.75 16.4365C11.9167 17.6032 13.3333 18.1865 15 18.1865Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `),a=t("toll_filled",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_66402"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="25">
                <rect
                    y="0.186523"
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_66402)">
                <path
                    d="M15 20.1865C12.7667 20.1865 10.875 19.4115 9.325 17.8615C7.775 16.3115 7 14.4199 7 12.1865C7 9.95319 7.775 8.06152 9.325 6.51152C10.875 4.96152 12.7667 4.18652 15 4.18652C17.2333 4.18652 19.125 4.96152 20.675 6.51152C22.225 8.06152 23 9.95319 23 12.1865C23 14.4199 22.225 16.3115 20.675 17.8615C19.125 19.4115 17.2333 20.1865 15 20.1865ZM5.625 19.4365C4.225 18.7865 3.10417 17.8115 2.2625 16.5115C1.42083 15.2115 1 13.7699 1 12.1865C1 10.6032 1.42083 9.16152 2.2625 7.86152C3.10417 6.56152 4.225 5.58652 5.625 4.93652C5.975 4.76986 6.29167 4.78236 6.575 4.97402C6.85833 5.16569 7 5.47819 7 5.91152C7 6.07819 6.94583 6.24069 6.8375 6.39902C6.72917 6.55736 6.59167 6.67819 6.425 6.76152C5.375 7.24486 4.54167 7.97402 3.925 8.94902C3.30833 9.92402 3 11.0032 3 12.1865C3 13.3699 3.30833 14.449 3.925 15.424C4.54167 16.399 5.375 17.1282 6.425 17.6115C6.59167 17.6949 6.72917 17.8115 6.8375 17.9615C6.94583 18.1115 7 18.2782 7 18.4615C7 18.8782 6.85833 19.1865 6.575 19.3865C6.29167 19.5865 5.975 19.6032 5.625 19.4365Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{h as Toll,a as TollFilled};
